interface TimerExtension {
    TIME_ELAPSED_EXT: number;
    GPU_DISJOINT_EXT: number;
}

/** Timer queries share wgpu's existing WebGL2 context; no render state is changed. */
export class GpuTiming {
    private pending: WebGLQuery[] = [];
    private active: WebGLQuery | null = null;
    private ext: TimerExtension | null;

    constructor(private gl: WebGL2RenderingContext, private report: (ms: number) => void) {
        this.ext = gl.getExtension('EXT_disjoint_timer_query_webgl2');
    }

    begin(enabled: boolean) {
        const { gl, ext } = this;
        if (!enabled || !ext || gl.isContextLost()) {
            this.clear();
            this.report(-1);
            return;
        }
        if (gl.getParameter(ext.GPU_DISJOINT_EXT)) {
            this.clear();
            this.report(-1);
            return;
        }
        while (this.pending.length && gl.getQueryParameter(this.pending[0], gl.QUERY_RESULT_AVAILABLE)) {
            const query = this.pending.shift()!;
            const ns = gl.getQueryParameter(query, gl.QUERY_RESULT) as number;
            gl.deleteQuery(query);
            if (Number.isFinite(ns) && ns >= 0) this.report(ns / 1e6);
        }
        if (this.pending.length < 3 && !gl.getQuery(ext.TIME_ELAPSED_EXT, gl.CURRENT_QUERY)) {
            this.active = gl.createQuery();
            if (this.active) gl.beginQuery(ext.TIME_ELAPSED_EXT, this.active);
        }
    }

    end() {
        if (this.active && this.ext) {
            this.gl.endQuery(this.ext.TIME_ELAPSED_EXT);
            this.pending.push(this.active);
            this.active = null;
        }
    }

    clear() {
        this.end();
        for (const query of this.pending) this.gl.deleteQuery(query);
        this.pending = [];
    }
}
